import { Colors } from '@/common/colors/colors';
import Input from '@/common/components/Input';
import PopUp from '@/common/components/PopUp';
import { useFormik } from 'formik';
import React from 'react';
import { ButtonWrapper } from '../../ResignTag.styled';
import { useRequestsContext } from '@/common/hooks/requestHook';
import Loading from '@/common/components/Loading';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import SubmitButton from '@/common/components/buttons/SubmitButton';
import {
	createResignTag,
	updateResignTag,
} from '@/API/repositories/resign-tag';

const ResignTagForm = ({ setShow, selectedTag, reload = () => {} }) => {
	const { makeRequest, hasUnfilledRequest } = useRequestsContext();
	const { addMessage } = useMessageQueueContext();

	const formik = useFormik({
		initialValues: {
			label: selectedTag?.label || '',
		},
		onSubmit: (values) => handleSubmit(values),
	});

	const handleSubmit = async (values) => {
		let label = values.label;

		if (!label.startsWith('#')) {
			label = `#${label}`;
		}

		const payload = {
			label,
		};

		const requestFn = selectedTag ? updateResignTag : createResignTag;

		const response = await makeRequest(
			requestFn.bind(null, payload, selectedTag?._id),
		);

		if (!response?.data) {
			return addMessage('Something went wrong', 'error');
		}

		addMessage('Success', 'success');
		setShow(false);
		reload();
	};

	return (
		<PopUp padding='10px 20px' setShow={setShow}>
			{hasUnfilledRequest(createResignTag, updateResignTag) && <Loading />}
			<form onSubmit={formik.handleSubmit}>
				<Input
					id={'label'}
					onChange={formik.handleChange}
					name='Label'
					value={formik.values.label}
					required
					color={Colors.darkBlue}
					width={80}
				/>
				<ButtonWrapper>
					<SubmitButton text='Save' />
				</ButtonWrapper>
			</form>
		</PopUp>
	);
};

export default ResignTagForm;
